import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Row, Space, theme } from 'antd';
import { useTranslation } from 'react-i18next';

enum FieldListStatus {
    active = 'active',
    inactive = 'inactive'
}

const fieldListStatusMap = {
    [FieldListStatus.active]: FieldListStatus.active,
    [FieldListStatus.inactive]: FieldListStatus.inactive
} as const;

interface Props {
    status: FieldListStatus;
}
export default function AdminPageTablesButton({ status }: Props) {
    const {
        token: { fontSizeIcon }
    } = theme.useToken();
    const { t } = useTranslation('admin');

    return (
        <Space size="small" align="center">
            <Row align="middle">
                {status === FieldListStatus.active ? (
                    <EyeOutlined style={{ fontSize: fontSizeIcon * 1.7, margin: 0 }} />
                ) : (
                    <EyeInvisibleOutlined style={{ fontSize: fontSizeIcon * 1.7, margin: 0 }} />
                )}
            </Row>
            {t(`ticketField.${status}`)}
        </Space>
    );
}

export { FieldListStatus, fieldListStatusMap };
